import React, { Component } from 'react';
require('./HomeHeader.scss');

class HomeHeader extends Component {
	render() {
		return (
			<div>
				<section className="Section Section--header Section--accented Section--hero Section--radialAccented">
					<div className="container">
						<div className="row">
							<div className="col-xs-12">
								<h1 className="Heading Heading--xl Heading--branded Heading--uppercase Heading--tight Heading--strong Heading--blockChildren-lg text-xs-center">
									<span className="Text--plain">THANK YOU FOR USING </span>
									<span className="Text--branded">MAGIC CARD BUYER</span>
								</h1>
							</div>
							<div className="col-xs-12 col-sm-8 offset-sm-2">
								<p className="Text Text--large Text--plain Text--spacedBottomMedium text-xs-center">
									We are becoming a part of something bigger &ndash; you can continue sending your cards to us via <a href="https://www.najada.games/campaign-redirect/magic-card-buyer-redirect" title="Najada Games" className="Link Link--branded Link--naturallyUnderlined">najada.games</a>.
								</p>
								<p className="Text Text--fadedWhite Text--noSpaceBottom text-xs-center">
									Don&rsquo;t worry, all unfinished orders will still be processed.
								</p>
							</div>
						</div>
					</div>
				</section>
			</div>
		)
	}
}

export default HomeHeader;



/** WEBPACK FOOTER **
 ** ./src/components/HomeHeader/HomeHeader.js
 **/